document.querySelectorAll('.share__button--twitter').forEach((button) => {
  button.addEventListener('click', (e) => {
    e.preventDefault();

    window.open(
      'https://twitter.com/intent/tweet?url=' +
        encodeURIComponent(window.location.href) +
        '&text=' +
        encodeURIComponent(document.title),
      '',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  });
});

document.querySelectorAll('.share__button--linkedin').forEach((button) => {
  button.addEventListener('click', (e) => {
    e.preventDefault();

    window.open(
      'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(window.location.href),
      '',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  });
});

document.querySelectorAll('.share__button--mail').forEach((button) => {
  button.addEventListener('click', (e) => {
    e.preventDefault();

    window.open(
      `mailto:?subject=${encodeURIComponent(document.title)}&body=${encodeURIComponent(window.location.href)}`
    );
  });
});